import { Trans } from 'react-i18next';
import '../../sass/_badgeOfferIsracard.scss';

const BadgeOfferIsracard = ({ size = 'md', style, 'data-testid': dataTestId }) => {
	return (
		<div className={`badge-offer-isracard badge-offer-isracard--${size}`} style={style} data-testid={dataTestId}>
			<div className="badge-offer-isracard__text">
				<Trans i18nKey="IsracardAndAmericanExpressCardholders" components={{ span: <span /> }} />
			</div>
		</div>
	);
};

export default BadgeOfferIsracard;
